import styled from "styled-components"

const SmoothScroll = styled.div``

export default SmoothScroll
